<div class="user-password-page">
  @if (!loading) {
    <div class="user-password-card">
      @if (!invalidLink) {
        <h1>{{ (linkType === 'user-invite' ? 'USER_PASSWORD.INVITE_TITLE' : 'USER_PASSWORD.RESET_TITLE') | translate }}</h1>
        <p>{{ 'USER_PASSWORD.DESCRIPTION' | translate:{ username: userUsername || userName || userEmail } }}</p>
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
          <label>{{ 'USER_PASSWORD.PASSWORD' | translate }}</label>
          <input type="password" formControlName="password" autocomplete="new-password"
            [class.input-invalid]="(form.controls.password.dirty || submitted) && form.controls.password.invalid"
            [class.input-valid]="form.controls.password.valid">
          @if (submitted && form.controls.password.errors?.['required']) {
            <small>{{ 'USER_PASSWORD.REQUIRED' | translate }}</small>
          }
          <div class="password-rules">
            <span class="password-rules-title">{{ 'USER_PASSWORD.REQUIREMENTS_TITLE' | translate }}</span>
            <ul>
              @for (rule of passwordRules; track rule) {
                <li [class.met]="isRuleMet(rule)">
                  <span class="rule-icon">{{ isRuleMet(rule) ? '✓' : '✗' }}</span>
                  {{ rule.key | translate: rule.params }}
                </li>
              }
            </ul>
          </div>
          <label>{{ 'USER_PASSWORD.CONFIRM_PASSWORD' | translate }}</label>
          <input type="password" formControlName="confirmPassword" autocomplete="new-password"
            [class.input-invalid]="(form.controls.confirmPassword.dirty || submitted) && (form.controls.confirmPassword.invalid || passwordMismatch)"
            [class.input-valid]="form.controls.confirmPassword.valid && !passwordMismatch">
          @if (submitted && form.controls.confirmPassword.errors?.['required']) {
            <small>{{ 'USER_PASSWORD.REQUIRED' | translate }}</small>
          }
          @if ((form.controls.confirmPassword.dirty || submitted) && form.value.confirmPassword && passwordMismatch) {
            <small>{{ 'USER_PASSWORD.MISMATCH' | translate }}</small>
          }
          <button type="submit" [disabled]="!canSubmit">{{ 'USER_PASSWORD.SUBMIT' | translate }}</button>
        </form>
      } @else {
        <h1>{{ 'USER_PASSWORD.LINK_INVALID_TITLE' | translate }}</h1>
        <p>{{ ('USER_PASSWORD.' + invalidLinkReason) | translate }}</p>
        <button type="button" (click)="goToLogin()">{{ 'USER_PASSWORD.BACK_TO_LOGIN' | translate }}</button>
      }
    </div>
  }
</div>
